// pages/_app.js
import {
  AuthProvider,
  ConsoleProvider,
  LibraryProvider,
  PlansProvider,
} from "contexts";
import useWorker from "hooks/useWorker";
import Console from "layout/Console";
import "styles/globals.scss";

export default function App({ Component, pageProps }) {
  useWorker();

  const providers = [
    AuthProvider,
    ConsoleProvider,
    LibraryProvider,
    PlansProvider,
  ];

  const wrapWithProviders = (children) =>
    providers.reduceRight(
      (acc, Provider) => <Provider>{acc}</Provider>,
      children
    );

  return wrapWithProviders(
    <div className="app">
      <Console>
        <Component {...pageProps} />
      </Console>
    </div>
  );
}
